import { type OpenApiSchemaYmlGoodsModerationStatus } from '#shared/api/schema';
import { PRODUCT_MODERATION_PENDING_STATUSES } from './constants';

export function isProductModerationPendingStatuses(
    statuses: unknown
): statuses is OpenApiSchemaYmlGoodsModerationStatus[] {
    return (
        Array.isArray(statuses) &&
        statuses.length === PRODUCT_MODERATION_PENDING_STATUSES.length &&
        PRODUCT_MODERATION_PENDING_STATUSES.every((status) => statuses.includes(status))
    );
}
